export default "__VITE_ASSET__04ea3f51__"